module.exports = __webpack_public_path__ + "static/media/bg2-5.a9538b61.jpg";